export default "__VITE_ASSET__Bo2maoOq__"